$(document).ready(function(){

  if ($('#loginpage').length) {
    console.log('Exist id: (loginpage)');
      $('.footer_area_shipBox').hide()
  }else{
      console.log('Not exist id: (loginpage)');
  }
  
  
   if ($('#registerpage').length) {
    console.log('Exist id: (loginpage)');
      $('.footer_area_shipBox').hide()
  }else{
      console.log('Not exist id: (loginpage)');
  }
  
  
  


});


